'use strict';

function CompanyObjectSkillsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/object-skills/:objectSkillId', {}, {
    'update': {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyObjectSkillsService', ['$resource', 'config', CompanyObjectSkillsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/object-skills/CompanyObjectSkillsService.js
// module id = 367
// module chunks = 0